export default __webpack_public_path__ + "static/media/Presentación_instrumento_Diagnostico_Convivencia_Escolar.63c11d52.pdf";